import { ENGAGEMENTS, IMAGES } from "../../data/config";
import { Reveal } from "../common/Reveal";

export const Engagements = () => (
  <section className="py-24 lg:py-32" data-testid="engagements-section">
    <div className="container-site">
      <Reveal>
        <p className="eyebrow">Track record</p>
        <h2 className="mt-4 max-w-2xl font-serif text-3xl tracking-tight text-navy sm:text-4xl lg:text-5xl">
          Selected <span className="italic text-emerald">Engagements</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-8 md:grid-cols-3">
        {ENGAGEMENTS.map((e, i) => (
          <Reveal key={e.id} delay={i * 0.08} className="h-full">
            <article
              className="flex h-full flex-col border border-navy/10 bg-white"
              data-testid={`engagement-card-${e.id}`}
            >
              <div className="overflow-hidden">
                <img
                  src={IMAGES[e.image]}
                  alt={`${e.organisation} engagement`}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-500 hover:scale-[1.02]"
                />
              </div>
              <div className="flex flex-1 flex-col p-7">
                <h3 className="font-serif text-xl text-navy">{e.organisation}</h3>
                <dl className="mt-5 flex-1 space-y-3 text-sm">
                  <div className="flex justify-between gap-4 border-b border-navy/5 pb-3">
                    <dt className="text-ink/50">Programme</dt>
                    <dd className="text-right text-ink/80">{e.programme || "To be confirmed"}</dd>
                  </div>
                  <div className="flex justify-between gap-4 border-b border-navy/5 pb-3">
                    <dt className="text-ink/50">Focus</dt>
                    <dd className="text-right text-ink/80">{e.focus || "To be confirmed"}</dd>
                  </div>
                  <div className="flex justify-between gap-4">
                    <dt className="text-ink/50">Year</dt>
                    <dd className="text-right text-ink/80">{e.year || "—"}</dd>
                  </div>
                </dl>
                {e.outcome && (
                  <p className="mt-5 border-l-2 border-gold pl-4 text-sm italic text-emerald">{e.outcome}</p>
                )}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
      <p className="mt-10 text-xs leading-relaxed text-ink/50" data-testid="engagements-note">
        Programme details and measurable outcomes are published only when
        confirmed and verified.
      </p>
    </div>
  </section>
);
